import { useState, useEffect } from 'react';

// Hook
const useSize = () => {
    // xs <576px
    // sm ≥576px
    // md ≥768px
    // lg ≥992px
    // xl ≥1200px
    // xxl ≥1400px
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => {
            return window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
};

export default useSize;
